import { NgModule } from '@angular/core';
import {
  MotifButtonModule,
  MotifHeaderModule,
  MotifIconModule,
  MotifProgressIndicatorModule,
  MotifVerticalNavigationModule,
  MotifProgressLoaderModule,
  MotifCardModule,
  MotifBadgeModule,
  MotifDropdownModule,
  MotifToastModule,
  MotifFormsModule,
  MotifTabNavigationModule,
  MotifChipModule,
  MotifAvatarModule,
  MotifModalModule,
  MotifFiltersModule,
  MotifAccordionModule,
  MotifPaginationModule,
  MotifBreadcrumbModule,
  MotifTooltipModule,
  MotifNativeDateTimeModule,
  MotifThemeModule,
} from '@ey-xd/ng-motif';

@NgModule({
  imports: [
    MotifHeaderModule,
    MotifButtonModule,
    MotifIconModule,
    MotifProgressIndicatorModule,
    MotifVerticalNavigationModule,
    MotifProgressLoaderModule,
    MotifCardModule,
    MotifBadgeModule,
    MotifDropdownModule,
    MotifToastModule,
    MotifFormsModule,
    MotifTabNavigationModule,
    MotifChipModule,
    MotifAvatarModule,
    MotifModalModule,
    MotifTabNavigationModule,
    MotifFiltersModule,
    MotifAccordionModule,
    MotifPaginationModule,
    MotifTooltipModule,
    MotifThemeModule,
    MotifNativeDateTimeModule,
  ],
  exports: [
    MotifHeaderModule,
    MotifButtonModule,
    MotifIconModule,
    MotifProgressIndicatorModule,
    MotifVerticalNavigationModule,
    MotifProgressLoaderModule,
    MotifCardModule,
    MotifBadgeModule,
    MotifDropdownModule,
    MotifToastModule,
    MotifFormsModule,
    MotifTabNavigationModule,
    MotifChipModule,
    MotifAvatarModule,
    MotifModalModule,
    MotifTabNavigationModule,
    MotifFiltersModule,
    MotifAccordionModule,
    MotifPaginationModule,
    MotifBreadcrumbModule,
    MotifTooltipModule,
    MotifThemeModule,
    MotifNativeDateTimeModule,
  ],
})
export class MotifModule {}
